import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const GAP = 12;

// Rides `el` upward once the footer scrolls into view so its bottom edge stays
// GAP px above the footer instead of overlapping it. Uses a `y` translate only
// (leaves `x` untouched for NotifStack) and reads the element's live rect each
// tick, so it works for fixed, sticky and stuck/unstuck cards alike — the shift
// we applied last frame is added back to recover the natural position.
export function initFooterClamp(el) {
  const footer = document.querySelector(".c-footer");
  if (!footer) return null;

  let shift = 0;

  const clamp = () => {
    const naturalBottom = el.getBoundingClientRect().bottom + shift;
    const overlap = naturalBottom - (footer.getBoundingClientRect().top - GAP);
    shift = Math.max(0, overlap);
    gsap.set(el, { y: -shift });
  };

  clamp();
  return ScrollTrigger.create({
    trigger: footer,
    start: "top bottom",
    end: "bottom top",
    onUpdate: clamp,
    onRefresh: clamp,
  });
}
